import { UserQuery } from "../graphql/menu.hooks";
import { GetMailHistoryQuery } from "../graphql/userAdministration.hooks";

export interface SelectOption {
  label: string;
  value: number;
}

export interface IMoveItems {
  pageIds: number[];
  folderIds: number[];
}

export enum PAGE_TYPE {
  DESKTOP = 1,
  MOBILE = 2,
  BOTH = 3,
}

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? DeepPartial<U>[]
    : T[P] extends object
      ? DeepPartial<T[P]>
      : T[P];
};

export type IUser = UserQuery["user"];

export type InvoiceLetter = NonNullable<
  GetMailHistoryQuery["userShow"]
>["invoiceLetters"][number];
